import React, { useState, useEffect } from 'react';
import { Modal, Table, Typography } from 'antd';
import axios from "./../../../services/http";
import DescargarArchivo from "./../../PendientesID/components/DescargarArchivo";
import config from "./../../../config";

const ModalVisualizacionArchivos = ({ relationship, openDialogFiles, cancelDialogFiles }) => {

    const [loading, setLoading] = useState(true);
    const [files, setFiles] = useState([]);
    const columns = [
        {
            title: 'ID',
            dataIndex: 'partida',
            key: 'partida'
        },
        {
            title: 'Archivo',
            dataIndex: 'file',
            render: (_, dataFile) => (
                <>
                    <Typography.Link onClick={()=> window.open(`${config.server}/static/documents/${dataFile.ruta}`, "_blank")}>
                        { dataFile.ruta }
                    </Typography.Link>
                </>
            )
        },
        {
            title: 'Descargar',
            dataIndex: 'download',
            render: (_, dataFile) => (
                <>
                    <DescargarArchivo
                        path={`static/documents/${dataFile.ruta}`}
                        nameFile={dataFile.ruta}
                    />
                </>
            )
        }
    ];

    useEffect(() => {
        GetFilesByRelationship();
    }, [relationship]);

    const GetFilesByRelationship = async () => {
        try {
            const response = await axios.HTTP_GET(`/api/v1/relationship/documents?partida=${relationship.id}&numRelacion=${relationship.numRelation}`);
            setFiles(response.files);
        } catch (error) {
            console.error('Error al obtener los archivos:', error);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Modal
                title={`Archivos Relacionados - Relación (${relationship.numRelation})`}
                open={openDialogFiles}
                onCancel={() => cancelDialogFiles(false)}
                footer={null}
                >
                <Table 
                    dataSource={files} 
                    columns={columns}
                    rowKey={record => record.ruta}
                    loading={loading} 
                />
            </Modal>
        </>
    )
}

export default ModalVisualizacionArchivos;